export default __webpack_public_path__ + "static/media/materialise-full-logo.be576502.svg";